import { useState, useRef, useEffect } from "react";
import { EditIcon, TrashIcon } from "lucide-react";
import ModalBare from "../../../../components/ModalBare";
import useModal from "../../../../hooks/useModal";
import { Button } from "@oc-labs/wt-storybook";

export default function LogoEditModal({ company, onSave }) {
  const modal = useModal("editLogo");
  const [image, setImage] = useState(company?.logo || "");
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (modal.isOpen) {
      setImage(company?.logo || "");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal.isOpen]);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
        // Limpiar input para evitar doble diálogo
        if (fileInputRef.current) fileInputRef.current.value = "";
      };
      reader.readAsDataURL(file);
    } else {
      // Limpiar input si no es imagen
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handleEditClick = () => {
    fileInputRef.current?.click();
  };

  const handleRemoveImage = () => {
    setImage("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSave = () => {
    onSave?.({ logo: image || "" });
    modal.close();
  };

  return (
    <ModalBare name="editLogo" title="Logo Settings" className="min-w-lg">
      <p className="text-sm text-gray-600 px-6 py-2">Configure the wallet login screen logo style</p>
      <div className="w-full">
        {image ? (
          <div className="flex flex-col items-center justify-center h-64 bg-gray-100 rounded-lg w-full py-30">
            <img src={image} alt="Logo" className="object-cover h-48 rounded-lg mb-4" />
            <div className="flex gap-4">
              <Button size="small" type="secondary" onClick={handleEditClick}>
                <EditIcon className="w-4 h-4" />
              </Button>
              <Button size="small" type="secondary" onClick={handleRemoveImage}>
                <TrashIcon className="w-4 h-4" />
              </Button>
            </div>
          </div>
        ) : (
          <div
            className="bg-gray-100 rounded-lg w-full flex flex-col items-center justify-center text-center cursor-pointer hover:bg-gray-200 transition py-20"
            onClick={handleEditClick}
          >
            <p className="text-gray-600 font-medium mb-4">Drag and drop logo file</p>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick();
              }}
              className="cursor-pointer ml-4 px-3 py-1 rounded-xl bg-white text-gray-900 text-md hover:bg-gray-50 transition-colors"
            >
              Upload file
            </button>
          </div>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          className="hidden"
        />
      </div>
      <div className="flex justify-center mt-8 px-8 mb-8 gap-4">
        <button
          type="button"
          onClick={() => {
            setImage("");
          }}
          className="px-8 py-2 rounded-3xl bg-gray-200 text-black font-medium hover:bg-gray-300 transition whitespace-nowrap cursor-pointer"
        >
          Reset to Default
        </button>
        <Button type="primary" onClick={handleSave} className="px-8">
          Save Changes
        </Button>
      </div>
    </ModalBare>
  );
}
